import { render, staticRenderFns } from "./CitySelector.vue?vue&type=template&id=56b3ed17&scoped=true"
import script from "./CitySelector.vue?vue&type=script&lang=js"
export * from "./CitySelector.vue?vue&type=script&lang=js"
import style0 from "./CitySelector.vue?vue&type=style&index=0&id=56b3ed17&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b3ed17",
  null
  
)

export default component.exports